import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "law"
};
const _hoisted_3 = { class: "wrapper_1" };
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'law',
    props: {
        common: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[4] || (_cache[4] = _createElementVNode("h2", null, "特定商取引法に基づく表記", -1)),
                            _createElementVNode("dl", null, [
                                _cache[2] || (_cache[2] = _createStaticVNode("<dt>提供事業者</dt><dd>ＳｈａｒｅＭｅｎｔｏｒｓ株式会社</dd><dt>代表者</dt><dd>堺 恒徳</dd><dt>サイト</dt><dd><a href=\"/\">https://sharementors.jp</a></dd><dt>所在地</dt><dd> 〒810-0041 <br class=\"sp\"> 福岡市中央区大名１丁目8-25 杉の宮マンション704 </dd><dt>連絡先</dt>", 9)),
                                _createElementVNode("dd", null, [
                                    _createVNode(_unref(Link), { href: "/inquiry" }, {
                                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                                            _createTextVNode("お問合せフォーム")
                                        ])),
                                        _: 1,
                                        __: [0]
                                    }),
                                    _cache[1] || (_cache[1] = _createTextVNode("よりご連絡ください。 "))
                                ]),
                                _cache[3] || (_cache[3] = _createStaticVNode("<dt>電話番号</dt><dd>０５０－１７８２－１８８５</dd><dt>メールアドレス</dt><dd>ｉｎｆｏ＠ｓｈａｒｅｍｅｎｔｏｒｓ．ｊｐ</dd><dt> サービス提供内容<br class=\"pc\"> および提供料 </dt><dd>サービスページにてにてご確認ください。</dd><dt>お支払い</dt><dd>クレジットカード（VISA/Master/JCB/AMEX）</dd><dt>サービス利用開始時期</dt><dd>会員登録後、直ちに利用することができます。</dd><dt>キャンセル・返金</dt><dd> 提供サービスの性質上、有料サービス決済後のキャンセルは受け付けておりません。<br> 会員が途中退会を行った場合でも、料金の返金はいたしません。 </dd><dt>解約・プラン変更</dt><dd>会員メニューからお手続きできます。</dd>", 14))
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
